import { render, staticRenderFns } from "./UploadPage.vue?vue&type=template&id=979e3c3e&scoped=true"
import script from "./UploadPage.vue?vue&type=script&lang=ts"
export * from "./UploadPage.vue?vue&type=script&lang=ts"
import style0 from "./UploadPage.vue?vue&type=style&index=0&id=979e3c3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979e3c3e",
  null
  
)

export default component.exports